import { collection, doc, getFirestore, onSnapshot, setDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { app } from '../../util/firebase';
import {Routes,Route, Link} from 'react-router-dom';
import UpdateClient from './UpdateClient';

const ListClients = (props) => {
    
    const [listPharmacies, setListPharmacies ] = useState([])
    const [clientID, setPosteID ] = useState("")

    useEffect(()=>{
        onSnapshot(collection(getFirestore(app),"users"),(snap)=>{
            setListPharmacies(snap.docs.map((snap)=> {
                let user = snap.data()
                user.id = snap.id
                return user
            }))
        })
    },[])

    const recoverArchived=(client)=>{
            client.isArchived = false
            setDoc(doc(getFirestore(app),"users",client.id),client)
            .then((res)=> alert('Le client a bien été récupèrée'))
            .catch(err=>alert(err))
    }

    const allHospitals = ()=>{
        let list = listPharmacies.filter(user=> user.status === 'client' && user.isArchived === props.isArchived)
        return list.map((client,index)=>{
            return(
                <tr key={index}>
                    <td><img style={{maxHeight:'40px'}} className="product-img" src={client.imgSrc}  alt="" /></td>
                    <td>{client.userName}</td>
                    <td>{client.adresse}</td>
                    <td>{client.email}</td>
                    
                    {
                        props.isArchived?
                        <td >
                            <button className="btn btn-warning" onClick={e=>recoverArchived(client)}>Recupérer</button>
                        </td>
                        :
                        <td>
                            <Link to="updateClient">
                                <button className="btn btn-primary" onClick={e=>setPosteID(client.id)}>Modifier</button>
                            </Link>
                        </td>
                    }
                </tr>
            )
        })
    }

    return (
        <div>
            <Routes>
                <Route path='' element={
                    <div className="col-12 bg-light p-3">
                        <table className="table table-striped table-hover border rounded">
                            <thead>
                                <tr className='bg-white '>
                                    <td>Image </td>
                                    <td>Nom Complet </td>
                                    <td>Adresse </td>
                                    <td>Email </td>
                                    <td>Action </td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    allHospitals()
                                }
                            </tbody>
                        </table>
                    </div>
           
                }></Route>
                <Route path='updateClient' element={<UpdateClient clientID = {clientID}/>}></Route>
            </Routes>
        </div>
    );
};

export default ListClients;